import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const notSelectedClass = "StatusToggle_statusText";
const lastItemToggleClass = "StatusToggle_toggleSelector--animator";
const colorClasses = {
	red: ["StatusToggle_statusText--red", "StatusToggle_toggleSelector--red"],
	blue: ["StatusToggle_statusText--blue", "StatusToggle_toggleSelector--blue"],
	grey: ["StatusToggle_statusText--grey", "StatusToggle_toggleSelector--grey"],
};

const StatusToggle = ({ onChange, selectedItem, items }) => {
	const getItemClassname = (item) => {
		const selectedClasses = colorClasses[item.color];
		return isSelectedItem(item) ? selectedClasses[0] : notSelectedClass;
	};

	const isSelectedItem = (item) => {
		return item.label === selectedItem.label;
	};

	const isSelectedItemLast = () => {
		return selectedItem.label === items[items.length - 1].label;
	};

	return (
		<div className="StatusToggle">
			{items.map((x) => (
				<div key={x.label} className={clsx(getItemClassname(x))} onClick={() => onChange(x)}>
					{x.label}
				</div>
			))}
			<div className={clsx(colorClasses[selectedItem.color][1], isSelectedItemLast() && lastItemToggleClass)} />
		</div>
	);
};

export default StatusToggle;

StatusToggle.propTypes = {
	onChange: PropTypes.func.isRequired,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			color: PropTypes.string,
		})
	).isRequired,
	selectedItem: PropTypes.shape({
		label: PropTypes.string,
		color: PropTypes.string,
	}).isRequired,
};
